
import { defineComponent,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';
import {useStore} from "vuex";
import router from "@/router";
import Header from '@/components/Header.component.vue'; // @ is an alias to /src
import SideBar from '@/components/SideBar.component.vue'; // @ is an alias to /src
import ListFiles from '@/components/ListFiles.component.vue'; // @ is an alias to /src
import HeaderFile from '@/components/HeaderFile.component.vue'; // @ is an alias to /src
import {IDoc,IFile} from "@/models/files.interface";
import {FilesService} from "@/services/files.service";
import {UserService} from "@/services/user.service";


export default defineComponent({
  components:{
    Header,
    SideBar,
    ListFiles,
    HeaderFile
  },
  setup(){

      const store = useStore();
      document.body.style.background = 'url('+require("@/img/11.jpg")+')';
      onMounted(()=>{
	try{
	const userStored =  serviceUser.fetch();
	  if(!userStored){
	    router.push("login");
	  }
	  
	}catch(err){
	  console.log(err);
	}
      });

      
      let files:Ref<IFile[]>= ref([]);
      const service = new FilesService();
      const serviceUser = new UserService();

      const asign = async() =>{
	files.value = await service.getAll(serviceUser.fetch().token,"unattended");
      };
      asign();

      const searchFiles = async(evento)=>{
	if (evento.status!=""){
	  files.value = await service.getAll(serviceUser.fetch().token,evento.status);
	}
      };
	const logout = ()=>{
         serviceUser.clean();
	 store.dispatch("set_current_user",{token:"",name:"",lastname:"",profiles:[]});
	try{

	router.push("login");
	}catch(err){
          console.log(err);
	}
      };//fin de logout
      
    return {files,searchFiles,logout};
  }//fin de setup
});

